import { sntLog } from "src/app/common/logger";

const logger = sntLog("DomainName");
let domainName = "";

export function getCurrentDomainName(): string {
  return domainName;
}

export function setDomainName(value: string): void {
  domainName = value;
  logger.debug(`domain name: "${value}"`);
}
